module.exports = __webpack_public_path__ + "static/media/Roland Headshot.847b4682.jpeg";